const getters = {
    /*getValueTest(state){
    	return state.value;
    },*/
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/home/getters.js